import React, {Component} from 'react';
import {Col, Form, Input, Label, FormGroup, Button} from 'reactstrap';
import * as customers from 'customers/actions/customers';
import {connect} from 'react-redux';
import {DetailContainer} from 'customers/DetailContainer';
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';

@connect(
    state => {
        return {
            customers: state.customers,
            auth: state.apa,
        }
    },
    dispatch => {
        return {
            fetchCustomer: (customer_id, callback) => {
                dispatch(customers.fetchCustomer(customer_id, callback))
            }
        }
    }
)
export default class CustomerParameters extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            isLoading: true,
            customer: null
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.fetchCustomer(id,
            customer => this.setState(
                {
                    isLoading: false,
                    customer: customer
                }
            ));
    }

    @autobind
    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            customer: {
                ...this.state.customer,
                [name]: value
            }
        })
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        this.setState({
            isSubmitting: true
        });
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const customer = this.state.customer;
        delete customer.offer_file;
        delete customer.contract_file;

        const body = JSON.stringify(customer);
        fetch(
            `/api/customers/${this.state.customer.id}/`,
            {headers, method: 'PATCH', body}
        ).then(res => res.json())
            .then(customer => this.setState({
                isSubmitting: false,
                customer: customer
            }))
    }


    render() {
        const id = this.props.match.params.id;
        const customer = this.state.customer;
        if (this.state.isLoading)
            return <Loading/>;
        return (
            <DetailContainer id={id}>
                <h1>{customer.name}</h1>
                <Form>
                    <FormGroup row>
                        <Label sm={2}>
                            Beschreibung
                        </Label>
                        <Col sm={10}>
                            <Input value={customer.beschreibung} type='textarea' name='beschreibung'
                                   onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>
                            Gesamt Gebäude
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.gesamt_gebaeude_flaeche} name={'gesamt_gebaeude_flaeche'}
                                   onChange={this.handleChange}/>
                        </Col>
                        <Label sm={2}>
                            Gesamt Freifläche
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.gesamt_gebaeude_frei} name={'gesamt_gebaeude_frei'}
                                   onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>
                            Gewerbe
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.gewerblich} name={'gewerblich'} onChange={this.handleChange}/>
                        </Col>
                        <Label sm={2}>
                            Tiefgarage
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.tiefgarage} name={'tiefgarage'} onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>
                            Andere1
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.andere1} name={'andere1'} onChange={this.handleChange}/>
                        </Col>
                        <Label sm={2}>
                            Andere2
                        </Label>
                        <Col sm={4}>
                            <Input value={customer.andere2} name={'andere2'} onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Button color={'primary'} onClick={this.onSubmit} disabled={this.state.isSubmitting}>
                            Speichern
                        </Button>
                    </FormGroup>
                </Form>
            </DetailContainer>
        )
    }
}